import * as React from "react";
import { Link } from "react-router-dom";
import { RootGridIcon } from "./RootGridIcon";
import { MdSource } from "react-icons/md";
import { GiReceiveMoney } from "react-icons/gi";
import { BsGearFill } from "react-icons/bs";
import { FaWarehouse } from "react-icons/fa";
import { HiClipboardDocumentCheck } from "react-icons/hi2";
import { FaHandsHelping } from "react-icons/fa";
import { MdFastfood } from "react-icons/md";
import { RiCustomerService2Fill } from "react-icons/ri";
import { FaChartLine } from "react-icons/fa";
import { FaCalendar } from "react-icons/fa";
import { FaColumns } from "react-icons/fa";

export function RootHomeGrid() {
  return (
    <div className="rectangles-grid">
      {/* SOURCING */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{ pathname: "https://sourcing.explorandes.app/" }}
          target="_blank"
          className="grid-item-enlace"
        >
          {/* <Link to={{ pathname: "https://so.explo.cloud/" }} target="_blank" className="grid-item-enlace"> */}
          <div className="grid-item-title">
            <h3>Sourcing</h3>
          </div>
          <div className="grid-item-icon">
            {/* <RootGridIcon variant="ver-ingresos" /> */}
            <MdSource fontSize={"4rem"} />
          </div>
        </Link>
      </div>

      {/* PRODUCT */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{ pathname: "https://product.explorandes.app/" }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>Product</h3>
          </div>
          <div className="grid-item-icon">
            {/* <RootGridIcon variant="ver-egresos" /> */}
            <HiClipboardDocumentCheck fontSize={"4rem"} />
          </div>
        </Link>
      </div>

      {/* VENTAS */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{ pathname: "https://sales.explorandes.app/" }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>Sales</h3>
          </div>
          <div className="grid-item-icon">
            {/* <RootGridIcon variant="ver-caja" /> */}
            <FaHandsHelping fontSize={"4rem"} />
          </div>
        </Link>
      </div>

      {/* OPERACIONES */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{ pathname: "https://operations.explorandes.app/" }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>Operations</h3>
          </div>
          <div className="grid-item-icon">
            {/* <RootGridIcon variant="nuevo-ingreso" /> */}
            <BsGearFill fontSize={"4rem"} />
          </div>
        </Link>
      </div>

      {/* ADMINISTRACION */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{ pathname: "https://financials.explorandes.app/auth" }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>Financials</h3>
          </div>
          <div className="grid-item-icon">
            {/* <RootGridIcon variant="nuevo-egreso" /> */}
            <GiReceiveMoney fontSize={"4rem"} />
          </div>
        </Link>
      </div>

      {/* warehouse */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{ pathname: "https://warehouse.explorandes.app/auth" }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>Warehouse</h3>
          </div>
          <div className="grid-item-icon">
            {/* <RootGridIcon variant="nuevo-registro" />
             */}

            <FaWarehouse fontSize={"4rem"} />
          </div>
        </Link>
      </div>

      {/* CLIENT */}
      {/* <div className="grid-item ver-proveedores">
				<Link to={{ pathname: "https://client.explorandes.app/" }} target="_blank" className="grid-item-enlace">
					<div className="grid-item-title">
						<h3>B2B</h3>
					</div>
					<div className="grid-item-icon">
						{/* <RootGridIcon variant="ver-egresos" /> *
						<IoMdBusiness fontSize={"4rem"}/>
					</div>
				</Link>
			</div>  */}

      {/* A & B */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{ pathname: "https://ayb.explorandes.app/" }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>A&B</h3>
          </div>
          <div className="grid-item-icon">
            {/* <RootGridIcon variant="ver-egresos" /> */}
            <MdFastfood fontSize={"4rem"} />
          </div>
        </Link>
      </div>

      {/* WEB */}
      <div className="grid-item ver-proveedores" style={{ display: `none` }}>
        <Link
          to={{ pathname: "https://web.explorandes.app/" }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>Web Explorandes</h3>
          </div>
          <div className="grid-item-icon">
            <RootGridIcon variant="ver-egresos" />
          </div>
        </Link>
      </div>

      {/* DESIGN */}
      <div className="grid-item ver-proveedores" style={{ display: `none` }}>
        <Link
          to={{ pathname: "https://design.explorandes.app/" }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>Design</h3>
          </div>
          <div className="grid-item-icon">
            <RootGridIcon variant="ver-egresos" />
          </div>
        </Link>
      </div>

      {/* ATENCION AL CLIENTE */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{ pathname: "https://sales.explorandes.app/" }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>Atención Al Cliente</h3>
          </div>
          <div className="grid-item-icon">
            <RiCustomerService2Fill fontSize={"4rem"} />
          </div>
        </Link>
      </div>

      {/* BI */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{
            pathname: "https://develop.d2hw5bdhvhj9v4.amplifyapp.com/login",
          }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>BI</h3>
          </div>
          <div className="grid-item-icon">
            <FaChartLine fontSize={"4rem"} />
          </div>
        </Link>
      </div>

      {/* Calendar */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{
            pathname: "https://salidasfijas.explorandes.app",
          }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>Calendar</h3>
          </div>
          <div className="grid-item-icon">
            <FaCalendar fontSize={"4rem"} />
          </div>
        </Link>
      </div>

      {/* Fixed departures */}
      <div className="grid-item ver-proveedores">
        <Link
          to={{
            pathname: "https://fixeddepartures.explorandes.com",
          }}
          target="_blank"
          className="grid-item-enlace"
        >
          <div className="grid-item-title">
            <h3>Fixed Departures</h3>
          </div>
          <div className="grid-item-icon">
            <FaColumns fontSize={"4rem"} />
          </div>
        </Link>
      </div>
    </div>
  );
}
